import { postRequest } from "@/utils/client/api";

const setWorkflowState = async (workflowId: number, state: JSON) => {
  return postRequest("api/workflow/updateState", { workflowId, state });
};

export default setWorkflowState;
